const config = {
    auth: {
        clientId: '9bdc2f7b-2c5b-4027-aca5-2150ad1b9039',
        // Only required if single tenant (remove if multi-tenant)
        authority:
          "https://login.microsoftonline.com/58b3d54f-16c9-42d3-af08-1fcabd095666",
      },
    redirectUri: process.env.REACT_APP_Redirect_URI,
    scopes: [
        'Calendars.Read.Shared',
        'Calendars.ReadWrite',
        'email',
        'offline_access',
        'openid',
        'profile',
        'User.Read'
    ]
  };
  
  export default config;

  //TODO https://docs.microsoft.com/en-us/graph/tutorials/react?tutorial-step=3#get-user-details